import React from 'react';

import { Selector } from '~pages/SipConfiguration/domain';

import BaseSelector from '../BaseSelector';

export default function DefaultSelector({ class: type, field, operation, value }: Selector) {
  return (
    <BaseSelector>
      [{type}] {field} {operation} {value}
    </BaseSelector>
  );
}
